import { gql } from '@apollo/client'

import * as f from '../../components/BPMTable/BPMInputs'
import { 
    DataMapper, 
    NumberComponentCreator,
    NumberLinkIconComponentCreator,
    DefaultClickStrategy, 
    TableFieldDescription,
    DataTransformer,
    DeleteSelectBudgetsActions,
} from '../../components/BPMTable/TableMapperCreator'
import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import TableCreatorCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreator'
import {DirectTableQueryBuilder} from "../../components/BPMTable/TableQueryBuilder/DirectTableQueryBuilder";


// tableQuery movido al test de DirectTableQueryBuilder

const editMutator = gql`
    mutation editBudgetMutation(
        $id: String!,
        $description: String,
        $amount: String!,
        $currency: String!,
        $startPeriod: String!,
        $endPeriod: String!
    ) {
        editBudget(
            id: $id,
            description: $description,
            amount: $amount,
            currency: $currency,
            startPeriod: $startPeriod,
            endPeriod: $endPeriod,
        ) {
            budget {
                id
            }
        }
    }
`

const newMutator = gql`
    mutation createBudgetMutation(
        $description: String,
        $amount: String!,
        $currency: String!,
        $startPeriod: String!,
        $endPeriod: String!
    ) {
        createBudget(
            description: $description,
            amount: $amount,
            currency: $currency,
            startPeriod: $startPeriod,
            endPeriod: $endPeriod,
        ) {
            budget {
                id
            }
        }
    }
`

const deleteMutator = gql`
    mutation deleteBudgetMutation($ids: [String!], $allRecords: Boolean, $filters: String) {
        deleteBudget(ids: $ids, allRecords: $allRecords, filters: $filters) {
            result
        }
    }
`

const unitQuery = `
    budget(id: $id) {
        id
        description
        amount
        startPeriod {
            date
        }
        endPeriod {
            date
        }
        currency {
            code
            symbol
        }
        budgetperiodSet {
            id
            glAccount {
                id
                name
                displayName
            }
            period {
                id
                date
            }
            value
        }
        unassignedAmount
    }
`

const BudgetTableCreatorQueries = {tableQueryBuilder: new DirectTableQueryBuilder('allBudgets'), editMutator, newMutator, deleteMutator, unitQuery}

const budgetFieldDescriptions = [
    new TableFieldDescription(
        'description',
        new DataMapper('description'),
        new f.FilterDescription(new f.TextFilter('description')),
        {label: 'Description'}
    ),
    new TableFieldDescription(
        'startPeriod',
        new DataMapper('startPeriod.date'),
        new f.FilterDescription(new f.PeriodFilter("startPeriod")),
        {label: 'Start Period'}
    ),
    new TableFieldDescription(
        'endPeriod',
        new DataMapper('endPeriod.date'),
        new f.FilterDescription(new f.PeriodFilter("endPeriod")),
        {label: 'End Period'}
    ),
    new TableFieldDescription(
        'currency',
        new DataMapper('currency.code'),
        new f.FilterDescription(new f.TextFilter("currency")),

        {label: 'Currency'}
    ),
    new TableFieldDescription(
        'amount',
        new DataMapper('id', 'amount', 'currency.code'),
        new f.FilterDescription(new f.NullCreator()),
        {
            label: 'Amount',
            componentCreator: new NumberLinkIconComponentCreator(2, '/budgetPeriod/', "View Budget details"),
            transform: new DataTransformer(({id, amount, code}) => ({id: id, value: Number(amount).toFixed(2), symbol: code})),
            fieldAlign: 'right'
        }
    ),
    new TableFieldDescription(
        'unassignedAmount',
        new DataMapper('unassignedAmount'),
        new f.FilterDescription(new f.NullCreator()),
        {
            label: 'Unassigned Amount',
            componentCreator: new NumberComponentCreator('', 2),
            excelTransform: new DataTransformer(({unassignedAmount})=>Number(unassignedAmount).toFixed(2)),
            fieldAlign: 'right'
        }
    ),
];

class BudgetTableCreator extends TableCreatorCreator {
    constructor(filters) {
        super(filters)
    }

    static getId = () => {
        return "BudgetTableCreator"
    }

    getTableCreator = (tableName) => {
        const tableCreator =  this.createTableCreator(this.constructor.getId(), tableName, BudgetTableCreatorQueries, new DefaultClickStrategy())
        tableCreator.setSelectedRowActionsStrategy(new DeleteSelectBudgetsActions(deleteMutator));

        tableCreator.addDescriptions(budgetFieldDescriptions)

        return tableCreator;
    }
}

tableCreatorCreatorFactoryCreator.addTableCreatorCreator(BudgetTableCreator)

export {
    BudgetTableCreator,
    BudgetTableCreatorQueries,
    budgetFieldDescriptions,
};
